import pkg from '../package.json';

/** Application version, single-sourced from package.json. */
export const VERSION: string = pkg.version;
